import { render } from "./BigCountInput.vue?vue&type=template&id=079898a7&scoped=true"
import script from "./BigCountInput.vue?vue&type=script&lang=js"
export * from "./BigCountInput.vue?vue&type=script&lang=js"

import "./bigCountInputStyle.scss?vue&type=style&index=0&id=079898a7&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-079898a7"]])

export default __exports__